import React from "react";
import { BlockVariant, Speaker } from "src/types";

import Button from "@/components/editor/primitives/button/button-component";
import { DEFAULT_SCHEDULES } from "@/components/editor/shared/constants";
import { VIDEO_AREA_SIZE_SMALL_TYPE } from "@/components/editor/shared/media/video-with-title-settings";
import { DEFAULT_NAVIGATION_LINKS } from "@/components/editor/shared/navigation";
import { conditionalShowList } from "@/hooks/use-widget-deprecation";
import getInitialItemsOrDefault from "@/utils/get-initial-items-or-default";

import { createThemeTemplateFactory, syncNavigationLinks } from "../utils";
import HeaderOption1 from "./blocks/headers/header-option-1/header-option-1-component";
import VideoWithTitle from "./blocks/media/video-with-title/video-with-title-component";
import StandaloneNavigation from "./blocks/navigations/standalone-navigation/standalone-navigation-component";
import DefaultSchedule from "./blocks/schedules/default-schedule/default-schedule-component";
import SyncedDefaultSchedule from "./blocks/schedules/default-schedule/synced-default-schedule-component";
import DividerPicture from "./blocks/sections/divider-picture/divider-picture-component";
import { DEFAULT_SPEAKERS } from "./blocks/speakers/constants";
import SpeakerCard from "./blocks/speakers/speaker-card/speaker-card-component";
import Speakers from "./blocks/speakers/speakers-component";
import SyncedSpeakers from "./blocks/speakers/synced-speakers-component";

export default createThemeTemplateFactory(
  (options) =>
    [
      <StandaloneNavigation key="standalone-navigation" showCta isSticky>
        {DEFAULT_NAVIGATION_LINKS.map(({ label, action }) => (
          <Button isLink key={label} text={label} action={action} />
        ))}
      </StandaloneNavigation>,
      <HeaderOption1
        key="header-option-1"
        backgroundImage="/canvas/hazel/images/background.d3b1da1a.jpg"
        isLogoShowing
        logoSize={50}
        imageFit="cover"
      />,
      <VideoWithTitle key="video" videoAreaSize={VIDEO_AREA_SIZE_SMALL_TYPE} />,
      ...conditionalShowList(BlockVariant.MANUAL, options, [
        <Speakers key="speakers">
          {getInitialItemsOrDefault<Speaker>(
            options.speakers,
            8,
            DEFAULT_SPEAKERS
          ).map((speaker) => (
            <SpeakerCard
              key={speaker.id + speaker.name}
              speaker={speaker}
              isBioAvailable={!!speaker.bio}
            />
          ))}
        </Speakers>,
        <DefaultSchedule
          key="schedule"
          schedules={
            options.schedules.length > 0 ? options.schedules : DEFAULT_SCHEDULES
          }
        />,
      ]),
      ...conditionalShowList(BlockVariant.SYNCED, options, [
        <SyncedSpeakers key="synced-speakers" />,
        <SyncedDefaultSchedule key="synced-schedule" />,
      ]),
      <DividerPicture
        key="divider-picture"
        backgroundImage="/canvas/hazel/images/divider-picture-placeholder.a6e28f04.jpg"
      />,
    ].filter((e) => Boolean(e)),
  (nodeTrees, query) => syncNavigationLinks(nodeTrees, query)
);
